import * as reqHandler from '../../config/services/serviceHandler';
import { clearDefaultError, rootApiResponse } from '../HeaderContainer/actions';
import endPoints from '../../config/endPoints';
import { utils } from '../../devUtils';
import { DEFAULT_ACTION } from '../HeaderContainer/constants';
import { errorResponse } from '../../devUtils/commonUtils';
import { FETCH_CARD_DATA_YBL, GetActiveCardDetails } from '../NetworkCards/constants';
import { PHYSICAL_CARD_ACTIONS } from './constants';

const physicalCardActionsSuccess = (payload) => ({ type: PHYSICAL_CARD_ACTIONS, payload });
const fetchCardDataSuccess = (payload) => ({ type: FETCH_CARD_DATA_YBL, payload });

export const PhysicalCardActions = (payload, otherParams) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endPoints.POST_PHYSICAL_CARD_ACTIONS, payload, authPrerequist);
    if (response && response.status) {
      const res = GetActiveCardDetails(response, otherParams.cardType);
      dispatch(physicalCardActionsSuccess(res));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(physicalCardActionsSuccess({ status: false }));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

export const fetchCardData = () => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    let res = null;
    res = await reqHandler.getHandler(api, endPoints.GET_WALLET_BALANCE_V3, {}, authPrerequist);
    if (res && res.status) {
      dispatch(fetchCardDataSuccess(res));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (res.message);
  } catch (err) {
    dispatch(fetchCardDataSuccess({ status: false }));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};



// WEBPACK FOOTER //
// client/containers/YesBankRenewalManagement/actions.js